import Component from './ManageStores';

export default Component;
